export function PrincipalsHeader() {
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <h1 className="mt-1 text-3xl font-extrabold tracking-tight text-slate-900">
        Principal Details
      </h1>
      <p className="mt-1 text-sm font-medium text-slate-600">
        Register or replace school principal using OTP verification.
      </p>
    </section>
  );
}
